import { ICreateItemControleUseCase } from "../../../presentation/useCases/create/create_item_controle_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class CreateItemControleUseCase implements ICreateItemControleUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async createItemControle( IdProdutoServico: number[] | null, IdControleEstoque: number
  ): Promise<void> {
    
    await this.repository.createItemControle(
    IdProdutoServico, IdControleEstoque
    );
    
  }
}
